"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.process = exports.processNamespace = exports.createEmptyMeta = exports.validateScopingSelector = exports.StylableProcessor = exports.processorWarnings = void 0;
const path_1 = __importDefault(require("path"));
const postcss = __importStar(require("postcss"));
const postcss_value_parser_1 = __importDefault(require("postcss-value-parser"));
const custom_values_1 = require("./custom-values");
const diagnostics_1 = require("./diagnostics");
const deprecated_selector_utils_1 = require("./deprecated/deprecated-selector-utils");
const murmurhash_1 = require("./murmurhash");
const native_reserved_lists_1 = require("./native-reserved-lists");
const stylable_meta_1 = require("./stylable-meta");
const diagnostics_2 = require("./features/diagnostics");
const features_1 = require("./features");
const stylable_utils_1 = require("./stylable-utils");
const process_declaration_functions_1 = require("./process-declaration-functions");
const selector_1 = require("./helpers/selector");
const rule_1 = require("./helpers/rule");
const stylable_value_parsers_1 = require("./stylable-value-parsers");
const utils_1 = require("./utils");
const deprecation_1 = require("./helpers/deprecation");
const validate_at_property_1 = require("./validate-at-property");
__exportStar(require("./stylable-meta"), exports); /* TEMP EXPORT */
const parseStates = stylable_value_parsers_1.SBTypesParsers[stylable_value_parsers_1.valueMapping.states];
const parseGlobal = stylable_value_parsers_1.SBTypesParsers[stylable_value_parsers_1.valueMapping.global];
const parseExtends = stylable_value_parsers_1.SBTypesParsers[stylable_value_parsers_1.valueMapping.extends];
exports.processorWarnings = {
    ROOT_AFTER_SPACING() {
        return '".root" class cannot be used after native elements or selectors external to the stylesheet';
    },
    STATE_DEFINITION_IN_ELEMENT() {
        return 'cannot define pseudo states inside a type selector';
    },
    STATE_DEFINITION_IN_COMPLEX() {
        return 'cannot define pseudo states inside complex selectors';
    },
    REDECLARE_SYMBOL_KEYFRAMES(name) {
        return `redeclare keyframes symbol "${name}"`;
    },
    KEYFRAME_NAME_RESERVED(name) {
        return `keyframes "${name}" is reserved`;
    },
    CANNOT_RESOLVE_EXTEND(name) {
        return `cannot resolve '${stylable_value_parsers_1.valueMapping.extends}' type for '${name}'`;
    },
    CANNOT_EXTEND_IN_COMPLEX() {
        return `cannot define "${stylable_value_parsers_1.valueMapping.extends}" inside a complex selector`;
    },
    UNKNOWN_MIXIN(name) {
        return `unknown mixin: "${name}"`;
    },
    OVERRIDE_MIXIN(mixinType) {
        return `override ${mixinType} on same rule`;
    },
    OVERRIDE_TYPED_RULE(key, name) {
        return `override "${key}" on typed rule "${name}"`;
    },
    PARTIAL_MIXIN_MISSING_ARGUMENTS(type) {
        return `"${stylable_value_parsers_1.valueMapping.partialMixin}" can only be used with override arguments provided, missing overrides on "${type}"`;
    },
    INVALID_NAMESPACE_DEF() {
        return 'invalid @namespace';
    },
    EMPTY_NAMESPACE_DEF() {
        return '@namespace must contain at least one character or digit';
    },
    NO_VARS_DEF_IN_ST_SCOPE() {
        return `cannot define "${stylable_value_parsers_1.rootValueMapping.vars}" inside of "@st-scope"`;
    },
    NO_KEYFRAMES_IN_ST_SCOPE() {
        return `cannot use "@keyframes" inside of "@st-scope"`;
    },
    MISSING_SCOPING_PARAM() {
        return '"@st-scope" missing scoping selector parameter';
    },
    MISSING_KEYFRAMES_NAME() {
        return '"@keyframes" missing parameter';
    },
    MISSING_KEYFRAMES_NAME_INSIDE_GLOBAL() {
        return `"@keyframes" missing parameter inside "${stylable_value_parsers_1.paramMapping.global}()"`;
    },
    ILLEGAL_GLOBAL_CSS_VAR(name) {
        return `"@st-global-custom-property" received the value "${name}", but it must begin with "--" (double-dash)`;
    },
    GLOBAL_CSS_VAR_MISSING_COMMA(name) {
        return `"@st-global-custom-property" received the value "${name}", but its values must be comma separated`;
    },
    ILLEGAL_CSS_VAR_USE(name) {
        return `a custom css property must begin with "--" (double-dash), but received "${name}"`;
    },
    ILLEGAL_CSS_VAR_ARGS(name) {
        return `custom property "${name}" usage (var()) must receive comma separated values`;
    },
    INVALID_NAMESPACE_REFERENCE() {
        return 'st-namespace-reference dose not have any value';
    },
    INVALID_NESTING(child, parent) {
        return `nesting of rules within rules is not supported, found: "${child}" inside "${parent}"`;
    },
    DEPRECATED_ST_GLOBAL_CUSTOM_PROPERTY() {
        return `"st-global-custom-property" is deprecated and will be removed in the next version. Use "@property" with ${stylable_value_parsers_1.paramMapping.global}`;
    },
    DEPRECATED_ST_FUNCTION_NAME: (name, alternativeName) => {
        return `"${name}" is deprecated, use "${alternativeName}"`;
    },
};
class StylableProcessor {
    constructor(diagnostics = new diagnostics_1.Diagnostics(), resolveNamespace = processNamespace) {
        this.diagnostics = diagnostics;
        this.resolveNamespace = resolveNamespace;
    }
    process(root) {
        this.meta = new stylable_meta_1.StylableMeta(root, this.diagnostics);
        features_1.STImport.hooks.analyzeInit(this);
        this.handleAtRules(root);
        const stubs = this.insertCustomSelectorsStubs();
        root.walkRules((rule) => {
            if (!(0, rule_1.isChildOfAtRule)(rule, 'keyframes')) {
                this.handleCustomSelectors(rule);
                this.handleRule(rule, (0, rule_1.isChildOfAtRule)(rule, stylable_value_parsers_1.rootValueMapping.stScope));
            }
            const parent = rule.parent;
            if ((parent === null || parent === void 0 ? void 0 : parent.type) === 'rule') {
                this.diagnostics.error(rule, exports.processorWarnings.INVALID_NESTING(rule.selector, parent.selector));
            }
        });
        root.walkDecls((decl) => {
            if (stylable_value_parsers_1.stValuesMap[decl.prop]) {
                this.handleDirectives(decl.parent, decl);
            }
            else if ((0, stylable_utils_1.isCSSVarProp)(decl.prop)) {
                this.addCSSVarDefinition(decl);
            }
            if (decl.value.includes('var(')) {
                this.handleCSSVarUse(decl);
            }
            this.collectUrls(decl);
        });
        stubs.forEach((s) => s && s.remove());
        this.meta.scopes.forEach((scope) => this.handleScope(scope));
        return this.meta;
    }
    insertCustomSelectorsStubs() {
        return Object.keys(this.meta.customSelectors).map((selector) => {
            if (this.meta.customSelectors[selector]) {
                const rule = postcss.rule({ selector });
                this.meta.ast.append(rule);
                return rule;
            }
            return null;
        });
    }
    handleCustomSelectors(rule) {
        (0, stylable_utils_1.expandCustomSelectors)(rule, this.meta.customSelectors, this.meta.diagnostics);
    }
    handleAtRules(root) {
        let namespace = '';
        const toRemove = [];
        root.walkAtRules((atRule) => {
            switch (atRule.name) {
                case 'st-import': {
                    features_1.STImport.hooks.analyzeAtRule({
                        context: this,
                        atRule,
                    });
                    break;
                }
                case 'namespace': {
                    const match = atRule.params.match(/["'](.*?)['"]/);
                    if (match) {
                        if (match[1].trim()) {
                            namespace = match[1];
                        }
                        else {
                            this.diagnostics.error(atRule, exports.processorWarnings.EMPTY_NAMESPACE_DEF());
                        }
                        toRemove.push(atRule);
                    }
                    else {
                        this.diagnostics.error(atRule, exports.processorWarnings.INVALID_NAMESPACE_DEF());
                    }
                    break;
                }
                case 'keyframes':
                    if (!(0, rule_1.isChildOfAtRule)(atRule, stylable_value_parsers_1.rootValueMapping.stScope)) {
                        this.meta.keyframes.push(atRule);
                        let { params: name } = atRule;
                        if (name) {
                            let global;
                            const globalName = (0, utils_1.globalValue)(name);
                            if (globalName !== undefined) {
                                name = globalName;
                                global = true;
                            }
                            if (name === '') {
                                this.diagnostics.warn(atRule, exports.processorWarnings.MISSING_KEYFRAMES_NAME_INSIDE_GLOBAL());
                            }
                            if (native_reserved_lists_1.reservedKeyFrames.includes(name)) {
                                this.diagnostics.error(atRule, exports.processorWarnings.KEYFRAME_NAME_RESERVED(name), {
                                    word: name,
                                });
                            }
                            this.checkRedeclareKeyframes(name, atRule);
                            this.meta.mappedKeyframes[name] = {
                                _kind: 'keyframes',
                                alias: name,
                                name,
                                global,
                            };
                        }
                        else {
                            this.diagnostics.warn(atRule, exports.processorWarnings.MISSING_KEYFRAMES_NAME());
                        }
                    }
                    else {
                        this.diagnostics.error(atRule, exports.processorWarnings.NO_KEYFRAMES_IN_ST_SCOPE());
                    }
                    break;
                case 'custom-selector': {
                    const params = atRule.params.split(/\s/);
                    const customName = params.shift();
                    toRemove.push(atRule);
                    if (customName && customName.match(stylable_utils_1.CUSTOM_SELECTOR_RE)) {
                        this.meta.customSelectors[customName] = atRule.params
                            .replace(customName, '')
                            .trim();
                    }
                    else {
                        // TODO: add warn there are two types one is not valid name and the other is empty name.
                    }
                    break;
                }
                case 'st-scope':
                    this.meta.scopes.push(atRule);
                    break;
                case 'property': {
                    this.addCSSVarDefinition(atRule);
                    (0, validate_at_property_1.validateAtProperty)(atRule, this.diagnostics);
                    break;
                }
                case 'st-global-custom-property': {
                    this.diagnostics.info(atRule, exports.processorWarnings.DEPRECATED_ST_GLOBAL_CUSTOM_PROPERTY());
                    const cssVarsByComma = atRule.params.split(',');
                    const cssVarsBySpacing = atRule.params
                        .trim()
                        .split(/\s+/g)
                        .filter((s) => s !== ',');
                    if (cssVarsBySpacing.length > cssVarsByComma.length) {
                        this.diagnostics.warn(atRule, exports.processorWarnings.GLOBAL_CSS_VAR_MISSING_COMMA(atRule.params), {
                            word: atRule.params,
                        });
                        break;
                    }
                    for (const entry of cssVarsByComma) {
                        const cssVar = entry.trim();
                        if ((0, stylable_utils_1.isCSSVarProp)(cssVar)) {
                            const property = {
                                _kind: 'cssVar',
                                name: cssVar,
                                global: true,
                            };
                            this.meta.cssVars[cssVar] = property;
                            features_1.STSymbol.addSymbol({
                                context: this,
                                symbol: property,
                                node: atRule,
                            });
                        }
                        else {
                            this.diagnostics.warn(atRule, exports.processorWarnings.ILLEGAL_GLOBAL_CSS_VAR(cssVar), { word: cssVar });
                        }
                    }
                    toRemove.push(atRule);
                    break;
                }
            }
        });
        toRemove.forEach((node) => node.remove());
        namespace = namespace || (0, utils_1.filename2varname)(path_1.default.basename(this.meta.source)) || 's';
        this.meta.namespace = this.handleNamespaceReference(namespace);
    }
    collectUrls(decl) {
        (0, process_declaration_functions_1.processDeclarationFunctions)(decl, (node) => {
            if (node.type === 'url') {
                this.meta.urls.push(node.url);
            }
        }, false);
    }
    handleStFunctions(decl) {
        (0, process_declaration_functions_1.processDeclarationFunctions)(decl, (node) => {
            if (node.type === 'nested-item' && custom_values_1.deprecatedStFunctions[node.name]) {
                const { alternativeName } = custom_values_1.deprecatedStFunctions[node.name];
                this.diagnostics.info(decl, exports.processorWarnings.DEPRECATED_ST_FUNCTION_NAME(node.name, alternativeName), {
                    word: node.name,
                });
            }
        }, false);
    }
    handleNamespaceReference(namespace) {
        let pathToSource;
        for (const node of this.meta.ast.nodes) {
            if (node.type === 'comment' && node.text.includes('st-namespace-reference')) {
                const i = node.text.indexOf('=');
                if (i === -1) {
                    this.diagnostics.error(node, exports.processorWarnings.INVALID_NAMESPACE_REFERENCE());
                }
                else {
                    pathToSource = (0, utils_1.stripQuotation)(node.text.slice(i + 1));
                }
                break;
            }
        }
        return this.resolveNamespace(namespace, pathToSource
            ? path_1.default.resolve(path_1.default.dirname(this.meta.source), pathToSource)
            : this.meta.source);
    }
    handleRule(rule, inStScope = false) {
        rule.selectorAst = (0, deprecated_selector_utils_1.parseSelector)(rule.selector);
        const selectorAst = (0, selector_1.parseSelectorWithCache)(rule.selector);
        let locallyScoped = false;
        let simpleSelector;
        (0, selector_1.walkSelector)(selectorAst, (node, ...nodeContext) => {
            const [index, nodes, parents] = nodeContext;
            const type = node.type;
            if (type === 'selector' && !(0, selector_1.isInPseudoClassContext)(parents)) {
                locallyScoped = false;
            }
            if (type !== `selector` && type !== `class` && type !== `type`) {
                simpleSelector = false;
            }
            if (node.type === 'pseudo_class') {
                if (node.value === 'import') {
                    features_1.STImport.hooks.analyzeSelectorNode({
                        context: this,
                        node,
                        rule,
                        walkContext: nodeContext,
                    });
                }
                else if (node.value === 'vars') {
                    if (rule.selector === stylable_value_parsers_1.rootValueMapping.vars) {
                        if ((0, rule_1.isChildOfAtRule)(rule, stylable_value_parsers_1.rootValueMapping.stScope)) {
                            this.diagnostics.warn(rule, exports.processorWarnings.NO_VARS_DEF_IN_ST_SCOPE());
                            rule.remove();
                            return selector_1.walkSelector.stopAll;
                        }
                        this.addVarSymbols(rule);
                        return selector_1.walkSelector.stopAll;
                    }
                    else {
                        this.diagnostics.warn(rule, diagnostics_2.generalDiagnostics.FORBIDDEN_DEF_IN_COMPLEX_SELECTOR(stylable_value_parsers_1.rootValueMapping.vars));
                    }
                }
                else if (!native_reserved_lists_1.knownPseudoClassesWithNestedSelectors.includes(node.value)) {
                    return selector_1.walkSelector.skipNested;
                }
            }
            else if (node.type === 'class') {
                features_1.CSSClass.hooks.analyzeSelectorNode({
                    context: this,
                    node,
                    rule,
                    walkContext: nodeContext,
                });
                locallyScoped = features_1.CSSClass.validateClassScoping({
                    context: this,
                    classSymbol: features_1.CSSClass.get(this.meta, node.value),
                    locallyScoped,
                    inStScope,
                    node,
                    nodes,
                    index,
                    rule,
                });
            }
            else if (node.type === 'type') {
                features_1.CSSType.hooks.analyzeSelectorNode({
                    context: this,
                    node,
                    rule,
                    walkContext: nodeContext,
                });
                locallyScoped = features_1.CSSType.validateTypeScoping({
                    context: this,
                    locallyScoped,
                    inStScope,
                    node,
                    nodes,
                    index,
                    rule,
                });
            }
            else if (node.type === `id`) {
                if (node.nodes) {
                    this.diagnostics.error(rule, diagnostics_2.generalDiagnostics.INVALID_FUNCTIONAL_SELECTOR(`#` + node.value, `id`), {
                        word: (0, selector_1.stringifySelector)(node),
                    });
                }
            }
            else if (node.type === `attribute`) {
                if (node.nodes) {
                    this.diagnostics.error(rule, diagnostics_2.generalDiagnostics.INVALID_FUNCTIONAL_SELECTOR(`[${node.value}]`, `attribute`), {
                        word: (0, selector_1.stringifySelector)(node),
                    });
                }
            }
            else if (node.type === `nesting`) {
                if (node.nodes) {
                    this.diagnostics.error(rule, diagnostics_2.generalDiagnostics.INVALID_FUNCTIONAL_SELECTOR(node.value, `nesting`), {
                        word: (0, selector_1.stringifySelector)(node),
                    });
                }
            }
            return;
        });
        if (simpleSelector !== false) {
            rule.isSimpleSelector = true;
            rule.selectorType = rule.selector.match(/^\./) ? 'class' : 'element';
        }
        else {
            rule.selectorType = 'complex';
        }
        // ToDo: check cases of root in nested selectors?
        if (!(0, selector_1.isRootValid)(selectorAst)) {
            this.diagnostics.warn(rule, exports.processorWarnings.ROOT_AFTER_SPACING());
        }
    }
    checkRedeclareKeyframes(symbolName, node) {
        const symbol = this.meta.mappedKeyframes[symbolName];
        if (symbol) {
            this.diagnostics.warn(node, exports.processorWarnings.REDECLARE_SYMBOL_KEYFRAMES(symbolName), {
                word: symbolName,
            });
        }
        return symbol;
    }
    addVarSymbols(rule) {
        rule.walkDecls((decl) => {
            this.collectUrls(decl);
            this.handleStFunctions(decl);
            let type = null;
            const prev = decl.prev();
            if (prev && prev.type === 'comment') {
                const typeMatch = prev.text.match(/^@type (.+)$/);
                if (typeMatch) {
                    type = typeMatch[1];
                }
            }
            const varSymbol = {
                _kind: 'var',
                name: decl.prop,
                value: '',
                text: decl.value,
                node: decl,
                valueType: type,
            };
            this.meta.vars.push(varSymbol);
            features_1.STSymbol.addSymbol({
                context: this,
                symbol: varSymbol,
                node: decl,
            });
        });
        rule.remove();
    }
    handleCSSVarUse(decl) {
        const parsed = (0, postcss_value_parser_1.default)(decl.value);
        parsed.walk((node) => {
            if (node.type === 'function' && node.value === 'var' && node.nodes) {
                const varName = node.nodes[0];
                if (!(0, stylable_value_parsers_1.validateAllowedNodesUntil)(node, 1)) {
                    const args = postcss_value_parser_1.default.stringify(node.nodes);
                    this.diagnostics.warn(decl, exports.processorWarnings.ILLEGAL_CSS_VAR_ARGS(args), {
                        word: args,
                    });
                }
                this.addCSSVar(postcss_value_parser_1.default.stringify(varName).trim(), decl, false);
            }
        });
    }
    addCSSVarDefinition(node) {
        let varName = node.type === 'atrule' ? node.params.trim() : node.prop.trim();
        let isGlobal = false;
        const globalVarName = (0, utils_1.globalValue)(varName);
        if (globalVarName !== undefined) {
            varName = globalVarName.trim();
            isGlobal = true;
        }
        if (node.type === 'atrule' && features_1.STSymbol.get(this.meta, varName)) {
            this.diagnostics.warn(node, features_1.STSymbol.diagnostics.REDECLARE_SYMBOL(varName), {
                word: varName,
            });
        }
        this.addCSSVar(varName, node, isGlobal);
    }
    addCSSVar(varName, node, global) {
        if ((0, stylable_utils_1.isCSSVarProp)(varName)) {
            if (!this.meta.cssVars[varName]) {
                const cssVarSymbol = {
                    _kind: 'cssVar',
                    name: varName,
                    global,
                };
                this.meta.cssVars[varName] = cssVarSymbol;
                const prevSymbol = features_1.STSymbol.get(this.meta, varName);
                const override = node.type === `atrule` || !prevSymbol;
                if (override) {
                    features_1.STSymbol.addSymbol({
                        context: this,
                        symbol: cssVarSymbol,
                        safeRedeclare: true,
                    });
                }
            }
        }
        else {
            this.diagnostics.warn(node, exports.processorWarnings.ILLEGAL_CSS_VAR_USE(varName), {
                word: varName,
            });
        }
    }
    handleDirectives(rule, decl) {
        const isSimplePerSelector = (0, selector_1.isSimpleSelector)(rule.selector);
        const type = isSimplePerSelector.reduce((accType, { type }) => {
            return !accType ? type : accType !== type ? `complex` : type;
        }, ``);
        const isSimple = type !== `complex`;
        if (decl.prop === stylable_value_parsers_1.valueMapping.states) {
            if (isSimple && type !== 'type') {
                this.extendTypedRule(decl, rule.selector, stylable_value_parsers_1.valueMapping.states, parseStates(decl.value, decl, this.diagnostics));
            }
            else {
                if (type === 'type') {
                    this.diagnostics.warn(decl, exports.processorWarnings.STATE_DEFINITION_IN_ELEMENT());
                }
                else {
                    this.diagnostics.warn(decl, exports.processorWarnings.STATE_DEFINITION_IN_COMPLEX());
                }
            }
        }
        else if (decl.prop === stylable_value_parsers_1.valueMapping.extends) {
            if (isSimple) {
                const parsed = parseExtends(decl.value);
                const symbolName = parsed.types[0] && parsed.types[0].symbolName;
                const extendsRefSymbol = features_1.STSymbol.get(this.meta, symbolName);
                if ((extendsRefSymbol &&
                    (extendsRefSymbol._kind === 'import' ||
                        extendsRefSymbol._kind === 'class' ||
                        extendsRefSymbol._kind === 'element')) ||
                    decl.value === this.meta.root) {
                    this.extendTypedRule(decl, rule.selector, stylable_value_parsers_1.valueMapping.extends, (0, stylable_utils_1.getAlias)(extendsRefSymbol) || extendsRefSymbol);
                }
                else {
                    this.diagnostics.warn(decl, exports.processorWarnings.CANNOT_RESOLVE_EXTEND(decl.value), { word: decl.value });
                }
            }
            else {
                this.diagnostics.warn(decl, exports.processorWarnings.CANNOT_EXTEND_IN_COMPLEX());
            }
        }
        else if (decl.prop === stylable_value_parsers_1.valueMapping.mixin || decl.prop === stylable_value_parsers_1.valueMapping.partialMixin) {
            const mixins = [];
            /**
             * This functionality is broken we don't know what strategy to choose here.
             * Should be fixed when we refactor to the new flow
             */
            stylable_value_parsers_1.SBTypesParsers[decl.prop](decl, (type) => {
                const symbol = features_1.STSymbol.get(this.meta, type);
                return (symbol === null || symbol === void 0 ? void 0 : symbol._kind) === 'import' && !symbol.import.from.match(/.css$/)
                    ? 'args'
                    : 'named';
            }, this.diagnostics, false).forEach((mixin) => {
                const mixinRefSymbol = features_1.STSymbol.get(this.meta, mixin.type);
                if (mixinRefSymbol &&
                    (mixinRefSymbol._kind === 'import' || mixinRefSymbol._kind === 'class')) {
                    if (mixin.partial && Object.keys(mixin.options).length === 0) {
                        this.diagnostics.warn(decl, exports.processorWarnings.PARTIAL_MIXIN_MISSING_ARGUMENTS(mixin.type), {
                            word: mixin.type,
                        });
                    }
                    const refedMixin = {
                        mixin,
                        ref: mixinRefSymbol,
                    };
                    mixins.push(refedMixin);
                    (0, deprecation_1.ignoreDeprecationWarn)(() => this.meta.mixins).push(refedMixin);
                }
                else {
                    this.diagnostics.warn(decl, exports.processorWarnings.UNKNOWN_MIXIN(mixin.type), {
                        word: mixin.type,
                    });
                }
            });
            const previousMixins = (0, deprecation_1.ignoreDeprecationWarn)(() => rule.mixins);
            if (previousMixins) {
                const partials = previousMixins.filter((r) => r.mixin.partial);
                const nonPartials = previousMixins.filter((r) => !r.mixin.partial);
                const isInPartial = decl.prop === stylable_value_parsers_1.valueMapping.partialMixin;
                if ((partials.length && decl.prop === stylable_value_parsers_1.valueMapping.partialMixin) ||
                    (nonPartials.length && decl.prop === stylable_value_parsers_1.valueMapping.mixin)) {
                    this.diagnostics.warn(decl, exports.processorWarnings.OVERRIDE_MIXIN(decl.prop));
                }
                if (partials.length && nonPartials.length) {
                    rule.mixins = isInPartial
                        ? nonPartials.concat(mixins)
                        : partials.concat(mixins);
                }
                else if (partials.length) {
                    rule.mixins = isInPartial ? mixins : partials.concat(mixins);
                }
                else if (nonPartials.length) {
                    rule.mixins = isInPartial ? nonPartials.concat(mixins) : mixins;
                }
            }
            else if (mixins.length) {
                rule.mixins = mixins;
            }
        }
        else if (decl.prop === stylable_value_parsers_1.valueMapping.global) {
            if (isSimple && type !== 'type') {
                this.setClassGlobalMapping(decl, rule);
            }
            else {
                // TODO: diagnostics - scoped on none class
            }
        }
    }
    setClassGlobalMapping(decl, rule) {
        const name = rule.selector.replace('.', '');
        const classSymbol = features_1.CSSClass.get(this.meta, name);
        if (classSymbol) {
            classSymbol[stylable_value_parsers_1.valueMapping.global] = parseGlobal(decl, this.diagnostics);
        }
    }
    extendTypedRule(node, selector, key, value) {
        const name = selector.replace('.', '');
        const typedRule = features_1.STSymbol.get(this.meta, name);
        if (typedRule && typedRule[key]) {
            this.diagnostics.warn(node, exports.processorWarnings.OVERRIDE_TYPED_RULE(key, name), {
                word: name,
            });
        }
        if (typedRule) {
            typedRule[key] = value;
        }
    }
    handleScope(atRule) {
        const scopingRule = postcss.rule({ selector: atRule.params });
        this.handleRule(scopingRule, true);
        validateScopingSelector(atRule, scopingRule, this.diagnostics);
        if (scopingRule.selector) {
            atRule.walkRules((rule) => {
                const scopedRule = rule.clone({
                    selector: (0, selector_1.scopeNestedSelector)((0, selector_1.parseSelectorWithCache)(scopingRule.selector), (0, selector_1.parseSelectorWithCache)(rule.selector)).selector,
                });
                scopedRule.stScopeSelector = atRule.params;
                rule.replaceWith(scopedRule);
            });
        }
        atRule.replaceWith(atRule.nodes || []);
    }
}
exports.StylableProcessor = StylableProcessor;
function validateScopingSelector(atRule, { selector: scopingSelector }, diagnostics) {
    if (!scopingSelector) {
        diagnostics.warn(atRule, exports.processorWarnings.MISSING_SCOPING_PARAM());
    }
}
exports.validateScopingSelector = validateScopingSelector;
function createEmptyMeta(root, diagnostics) {
    (0, utils_1.deprecated)('createEmptyMeta is deprecated and will be removed in the next version. Use "new StylableMeta()"');
    return new stylable_meta_1.StylableMeta(root, diagnostics);
}
exports.createEmptyMeta = createEmptyMeta;
function processNamespace(namespace, source) {
    return namespace + (0, murmurhash_1.murmurhash3_32_gc)(source); // .toString(36);
}
exports.processNamespace = processNamespace;
function process(root, diagnostics = new diagnostics_1.Diagnostics(), resolveNamespace) {
    return new StylableProcessor(diagnostics, resolveNamespace).process(root);
}
exports.process = process;
//# sourceMappingURL=stylable-processor.js.map